import { useCallback, useEffect, useState } from 'react';
import type { CourseDTO } from '../model/CourseDTO';
import type { AxiosError } from 'axios';
import fetchAuthenticatedFromBackend from '../api/fetchAuthenticatedFromBackend';

export default function useInternCourseById(id: string) {
  const [course, setCourse] = useState<CourseDTO | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<null | AxiosError>(null);

  const load = useCallback(() => {
    setLoading(true);
    fetchAuthenticatedFromBackend<CourseDTO>(`intern/v2/event/${id}`)
      .then((res) => {
        setCourse(res);
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    if (id !== '0') load();
  }, [id, load]);

  return { course, loading, fetchError: error };
}
